/*
 * @Description: 已支付
 * @Date: 2020-12-12 17:48:46
 */
import fields from './fields';
import search from './search';

import TableRenderClass from '@/components/tableRender/tableRenderClass';
import {
  listPayOrderPeopleAndSupplie,
  totalPayOrderPeopleAndSupplie,
  comprehensive
} from '@/api/ajax';

let example = new TableRenderClass({ fields, search });

// 页面入口
const part = example.createPart({
  name: '订单详情',
  list: comprehensive.comprehensivePeopleList,
  search: ['fullName', 'userPhone'],
  fields: [
    'index',
    'fullName',
    'userPhone',
    'finishPayPrice',
    'finishSumTaskPrice',
    'csoServiceScale',
    'totalPrice',
    'totalPrice1'
  ]
});
const partA = example.createPart({
  name: '订单详情',
  list: listPayOrderPeopleAndSupplie,
  fields: ['index', 'orderNo', 'taskDt', 'supplier', 'orderPrice', 'payStatus']
});
// individualAjax 为独立注册字段，用于获取总价接口
export default [
  {
    name: '订单详情',
    childMenu: [
      { ...part, individualAjax: comprehensive.comprehensivePeopleList }
    ]
  },
  {
    name: '订单详情',
    childMenu: [{ ...partA, individualAjax: totalPayOrderPeopleAndSupplie }]
  }
];
